// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2CilB","AppBody":"style_AppBody__7B4B3"};